module.exports = __FOREMAN_VENDOR__REACT_DIFF_VIEW__;